import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12 2.00004C8.06398 2.00004 4.73596 4.91377 4.21576 8.81524L3.31065 15.6035C3.07086 17.402 4.46997 19 6.28434 19H7.35361C8.25776 20.7479 9.96134 22 12 22C14.0386 22 15.7422 20.7479 16.6463 19H17.7156C19.53 19 20.9291 17.402 20.6893 15.6035L19.7842 8.81524C19.264 4.91377 15.936 2.00004 12 2.00004ZM14.2217 19H9.77821C10.3871 19.6373 11.1767 20 12 20C12.8232 20 13.6128 19.6373 14.2217 19Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M4.60189 1.98256C5.02467 2.33791 5.07933 2.96871 4.72398 3.39149C3.75209 4.54779 3.05165 5.93763 2.71854 7.46366C2.60075 8.00324 2.06786 8.34517 1.52828 8.22739C0.988699 8.10961 0.646766 7.57671 0.764549 7.03713C1.16858 5.1862 2.01781 3.50277 3.19296 2.10465C3.54831 1.68187 4.17911 1.62721 4.60189 1.98256ZM19.3981 1.98256C19.8209 1.62721 20.4517 1.68187 20.807 2.10465C21.9822 3.50278 22.8314 5.1862 23.2354 7.03713C23.3532 7.57671 23.0113 8.10961 22.4717 8.22739C21.9321 8.34517 21.3992 8.00324 21.2814 7.46366C20.9483 5.93763 20.2479 4.54779 19.276 3.39149C18.9206 2.96871 18.9753 2.33791 19.3981 1.98256Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }